import { ISize } from '../size'

const size: ISize = {
    mainContainerHeight: '100vh',
    mainContainerWidth: '100vw',
}

export { size }
